/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const oneOffPaymentNoticePostRequestSchema = z.object({
  amount: z.string(),
  reference: z.string(),
});
